import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';

import Layout from './layout/layout';
import Home from './pages/home';
import NotFound from './pages/not-found';

/*
 * The company page is a single page. The former /about and /prepbox-ai pages were
 * video-era content that now contradicts the stated belief, so both redirect home
 * rather than 404 — inbound links and old bookmarks still land somewhere correct.
 */
const router = createBrowserRouter([
    {
        path: '/',
        element: <Layout />,
        children: [
            { index: true, element: <Home /> },
            { path: 'about', element: <Navigate to="/#belief" replace /> },
            { path: 'prepbox-ai', element: <Navigate to="/#products" replace /> },
            { path: '*', element: <NotFound /> },
        ],
    },
]);

function App() {
    return <RouterProvider router={router} />;
}

export default App;
